import { NameCellRenderer } from "../cell_renderers";
import { TABLE_INFO } from "../shared/table_config";

const { HEADER_LABEL: tableHeader, PROPS: tableProps } =
  TABLE_INFO.ONPREM_LOWEST_COMPLIANCE;

export const onPremLowestComplianceColumnDefs = [
  {
    headerName: tableHeader.NAME,
    field: tableProps.NAME,
    flex: 5,
    filter: false,
    cellRenderer: NameCellRenderer,
    cellRendererParams: {
      fieldMapping: {
        ...tableProps,
      },
    },
    lockPosition: true,
    lockPinned: true,
  },
  // {
  //   headerName: tableHeader.NIST,
  //   field: tableProps.NIST,
  //   flex: 5.5,
  //   valueGetter: (params: any) => {
  //     const compliance = params.data.compliance || [];
  //     const nistData = compliance.find((c: any) => c.name === tableHeader.NIST);
  //     return nistData ? nistData.percentage : 0;
  //   },
  //   cellRenderer: ComplianceCellRenderer,
  //   filter: false,
  //   sortable: true,
  //   sort: "asc",
  // },
  // {
  //   headerName: tableHeader.CSC,
  //   field: tableProps.CSC,
  //   flex: 4.5,
  //   valueGetter: (params: any) => {
  //     const compliance = params.data.compliance || [];
  //     const cscData = compliance.find((c: any) => c.name === tableHeader.CSC);
  //     return cscData ? cscData.percentage : 0;
  //   },
  //   cellRenderer: ComplianceCellRenderer,
  //   filter: false,
  //   sortable: true,
  //   sort: "asc",
  // },
];
